




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonCheck from 'components/presenter/item/topic/viewer/ButtonCheck.vue'
import { QuizSlideResult, SlideParamsValuesSet } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    MarkdownViewerCrdt,
    ButtonCheck
  }
})
export default class ItemTopicViewerNumber extends Vue {
  response = ''

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonShowAlways!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: number | undefined

  @Watch('value', { immediate: true })
  update (value: number | undefined) {
    this.response = value === null || isNaN(value as number) ? '' : `${value}`
  }

  get text () {
    return this.slide?.text?.getText()
  }

  get canRespond () {
    return !(this.readonly || this.feedbackButtonOn)
  }

  respond (value: string) {
    if (this.canRespond) {
      this.response = value
      this.$emit('input', value === '' ? undefined : +value )
    }
  }
}
